// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-ask-question--header{padding-right:0;padding-left:0;height:auto!important}.lad-ask-question--header h2{font-size:30px}.lad-ask-question--header span{text-transform:uppercase;font-size:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
